import useTaxPaymentApi from "./taxPaymentApi";

export default useTaxPaymentApi;
